<template>
<!-- One card in gallery -->
<div class="card shadow-sm">
    <img class="card-img-top" :src="gc_image" width="100%" role="img" aria-label="Placeholder:Album" preserveAspectRatio="xMidYMid slice" focusable="false"><title>Placeholder</title><rect width="100%" height="100%" fill="#55595c"/><text x="50%" y="50%" fill="#eceeef" dy=".3em">{{gc_title}}</text>
    <div class="card-body">
        <p class="card-text">{{gc_subtitle}}</p>
        <div class="d-flex justify-content-between align-items-center">
        <div class="btn-group">
            <button type="button" class="btn btn-sm btn-outline-secondary"><van-icon v-for="i in [1,2,3,4,5]" :key="i" name="star" class="c-red" /></button>
            <button type="button" class="btn btn-sm btn-outline-secondary"><van-icon name="good-job-o" /></button>
        </div>
        <van-icon name="like-o" class="c-red" />
        </div>
    </div>
</div>
</template>
<script>
  import { onMounted } from 'vue'
  export default {
    name: 'Item',
    props: {
        gc_image: {
            type: String,
            default: ''
        },
        gc_title: {
            type: String,
            default: ''
        },
        gc_subtitle: {
            type: String,
            default: ''
        }
        
    },
    setup() {
        
        onMounted(() => {
            console.log("gallery card mounted!")
        })
        

        return {}
    }
  };
</script>
<style lang="scss" scoped>
</style>